<template>
  <div class="container-fluid recover-password">
    <div class="row">
      <div class="col-10 offset-1 col-md-6 offset-md-3">
        <div class="mb-4 text-center">
          <img src="../assets/logo-02.png" class="img-fluid logo-img" alt="Plantsss">
          <p class="logo-text">GET FREE PLANTSSS</p>
          <div class="store-logo-container">
            <a v-bind:href="appstoreUrl" target="_blank">
              <img src="../assets/appstore.png" class="img-fluid store-logo" alt="">
            </a>
            <a v-bind:href="playstoreUrl" target="_blank">
              <img src="../assets/playstore.png" class="img-fluid store-logo" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <form @submit="sendForm">
      <div v-if="!sentMail" class="row">
        <div class="col-10 offset-1 col-md-6 offset-md-3">
          <p class="text-center mt-4">Ingresa tu correo para poder recuperar tu contraseña</p>
        </div>

        <div class="col-10 offset-1 col-md-6 offset-md-3">
          <div class="form-group mt-4">
            <input
              v-model.trim="email"
               v-bind:class="{ 'is-invalid' : errors.email.length > 0 }"
              id="email" type="email" class="form-control"
              aria-describedby="emailHelp" placeholder="Correo" required>

              <small v-if="errors.email.length > 0" id="emailHelp" class="form-text text-danger">
                {{ errors.email }}
              </small>
          </div>
        </div>

        <div class="col-10 offset-1 col-md-6 offset-md-3">
          <input type="submit" class="btn btn-plantsss" value="Enviar">
        </div>
      </div>

      <div v-if="sentMail" class="row">
        <div class="col-10 offset-1 text-center">
          <span class="see-mail mt-4 mb-4">Por favor, revisa tu casilla de correo</span>
          <span class="see-unwanted">(incluso la casilla de 'No Deseados')</span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
const axios = require('axios');

export default {
  name: 'RecoverPassword',
  data() {
    return {
      appstoreUrl: process.env.VUE_APP_APPSTORE_URL,
      playstoreUrl: process.env.VUE_APP_PLAYSTORE_URL,
      email: '',
      sentMail: false,
      errors: {
        email: '',
      },
    };
  },
  created() {
    document.title = 'Recuperar Contraseña | Plantsss';
  },
  methods: {
    sendForm(e) {
      const url = (process.env.NODE_ENV === 'production')
        ? `${process.env.VUE_APP_API_SERVER}/api/v1/user/recover_password`
        : '/prod/api/v1/user/recover_password';

      axios.post(url, {
        email: this.email,
      })
        .then((response) => {
          const { status, msg } = response.data;

          if (status !== 1) {
            this.errors.email = msg;
          } else {
            this.sentMail = true;
          }
        })
        .catch((error) => {
          console.error(error);
          this.errors.email = 'Ha ocurrido un error';
        });

      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
  .recover-password {
    min-height: 100vh;
    background-image: url('../assets/recover-password/bottom-background.png');
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center bottom;
    background-size: 90%;
    color: rgba(0, 0, 0, 0.87);

    .store-logo-container {
      position: relative;
      z-index: 1;
    }

    .logo-text {
      font-weight: 100;
      font-size: small;
      margin-top: -3em;
      width: 50%;
    }

    p {
      font-weight: 400;
      font-size: larger;
    }

    form {
      margin-top: 3em;

      input[type=submit] {
        color: #ffffff;
      }
    }

    span.see-mail {
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 1.33;
      display: block;
    }

    span.see-unwanted {
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.75;
    }

    .store-logo {
      width: 5em;
      float: left;
      padding-left: 0.5em;
      margin-top: -9px;
      z-index: 10;
    }
  }

  @media (min-width: 576px) {
    .recover-password {
      background-size: 50%;

      .logo-text {
        margin-top: -6em;
      }

      .store-logo-container {
        padding-left: 70px;

        .store-logo {
          width: 7em;
          height: auto;
        }
      }
    }
  }
</style>
